import React from 'react';
import Divider from 'material-ui/Divider';
import * as colors from 'material-ui/styles/colors';
import * as commons from '../commons';

const FormAmmountTotalLabel = ({title, total, addContents, color}) => {

  let totalColor
  if (color && total && total !== 'ー') {
    totalColor = new String(total).charAt(0) !== '-' ? {color: colors.blue700} : {color: colors.red400}
  } else {
    totalColor = {color: colors.grey600}
  }

  return (
    <div className="row" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 30 }}>

      <div className="col-12">
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <div style={{ width: '100%' }}>
            <span style={{ color: colors.grey600 }}>{title}</span>
            <Divider />
          </div>
          <div style={{ width: 'atuo', textAlign: 'right' , ...totalColor}}>
            <span style={{ fontSize: 20 }}>{commons.dispMoney(total)}</span>
            {addContents}
            <Divider />
          </div>
        </div>
      </div>

    </div>
  )

}

export default FormAmmountTotalLabel


// WEBPACK FOOTER //
// ./src/components/FormAmmountTotalLabel.js